import { useEffect, useState } from "react";

/**
 * Tracks whether `query` currently matches, via `window.matchMedia` — for the rare case a plain
 * CSS media query isn't enough because the RENDER itself needs to branch (e.g. `GamebookScreen`'s
 * mobile play-card layout vs. its desktop grid table: mounting both and hiding one with
 * `display: none` would double the real DOM cost of a 150+ row list). Most responsive layout in
 * this app is pure CSS (see every other `@media` in `features/spotter/**`) — reach for this hook
 * only when CSS-only hide/show would mount work you don't want done at all on the other side of
 * the breakpoint.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const listener = () => setMatches(mql.matches);
    listener();
    mql.addEventListener("change", listener);
    return () => mql.removeEventListener("change", listener);
  }, [query]);

  return matches;
};
